/** Display-safe masking for mobile numbers and VUA (revocation platform pattern). */

const MIDDLE_MASK = '******';

const normalizeIndianMobileDigits = (digits) => {
	if (digits.length === 12 && digits.startsWith('91')) {
		return digits.slice(2);
	}
	if (digits.length > 10) {
		return digits.slice(-10);
	}
	return digits;
};

/** First digit + ****** + last 3 (e.g. 9******002). */
export const maskLocalPartForDisplay = (local) => {
	if (local == null || local === '') return '';
	const str = String(local).trim();
	const digits = str.replace(/\D/g, '');
	const normalized = normalizeIndianMobileDigits(digits);

	if (normalized.length >= 4) {
		return `${normalized[0]}${MIDDLE_MASK}${normalized.slice(-3)}`;
	}
	if (str.length >= 4) {
		return `${str[0]}${MIDDLE_MASK}${str.slice(-3)}`;
	}
	return '****';
};

export const maskMobileForDisplay = (mobile) => {
	if (mobile == null || mobile === '') return '';
	return maskLocalPartForDisplay(mobile);
};

/** e.g. 9******002@finvu */
export const maskVuaForDisplay = (vua) => {
	if (vua == null || vua === '') return '';
	const str = String(vua).trim();
	const atIndex = str.indexOf('@');
	if (atIndex === -1) {
		return maskLocalPartForDisplay(str);
	}
	const local = str.slice(0, atIndex);
	const domain = str.slice(atIndex);
	return `${maskLocalPartForDisplay(local)}${domain}`;
};
